import React, { memo } from 'react';
import { styled } from '@mui/material';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

import Td from '../../../../../components/common-table/components/Td';
import extractCompanyName from '../../../../../utils/extractCompanyName';

import scss from '../SonarCreationForm.module.scss';

const LinkCell = ({ links }) => {
  return (
    <Td isLeft extraClasses={scss.linkBodyCell}>
      {(links || []).map(({ url }) => {
        const extractedCompanyName = extractCompanyName(url);

        return (
          <StyledTooltip key={url} title={url} placement='top' disableInteractive arrow>
            <a className={scss.companyLink} href={url} target='_blank' rel='noreferrer'>
              {extractedCompanyName}
            </a>
          </StyledTooltip>
        );
      })}
    </Td>
  );
};

const StyledTooltip = styled(({ className, ...props }) => <Tooltip {...props} classes={{ popper: className }} />)({
  [`& .${tooltipClasses.tooltip}`]: {
    background: 'var(--table-row-bg-hover)',
    color: 'var(--text-stressed)',
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
    fontFamily: 'Inter',
    fontSize: '12px',
    padding: '8px',
    maxWidth: 'unset',
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: 'var(--table-row-bg-hover)',
  },
  [`& .${tooltipClasses.tooltipPlacementTop}`]: {
    bottom: '-8px',
  },
});

export default memo(LinkCell);
